import { Box } from 'braid-design-system';

import {
  LikeButton,
  ShowRepliesButton,
  ReplyButton,
} from 'src/components/atoms/Buttons';
import { useReplies } from 'src/provider/replies';

interface CommentReactionBarProps {
  likeLabel: string;
  likeStatus: boolean;
  onLikeClick: () => void;
  onCommentClick: () => void;
  showRepliesClick: () => void;
  isReplyClicked?: boolean;
}
export default ({
  likeLabel,
  likeStatus,
  onLikeClick,
  onCommentClick,
  showRepliesClick,
  isReplyClicked = false,
}: CommentReactionBarProps) => {
  const {
    replyState: { totalReplyCount: replyCount },
  } = useReplies();
  return (
    <Box display="flex" alignItems="center" padding="none">
      <LikeButton
        likeLabel={likeLabel}
        likeStatus={likeStatus}
        onClick={onLikeClick}
      />
      <ReplyButton onCommentClick={onCommentClick} />
      {replyCount !== 0 && (
        <ShowRepliesButton
          replies={replyCount}
          onClick={showRepliesClick}
          isClicked={isReplyClicked}
        />
      )}
    </Box>
  );
};
